import React from "react";
import {Container, Section} from "react-bulma-components";
import PropTypes from "prop-types";
import styled, {css} from "styled-components";
import BottomCenterSvg from "../assets/wave-bottom-center.svg";
import BottomRightSvg from "../assets/wave-bottom-right.svg";
import TopBalancedSvg from "../assets/wave-top-balanced.svg";
import media from "../styles/media";

const StyledSection = styled(Section)`
  position: relative;
  
`;

const Wave = ({orientation, ...props}) => {
    switch (orientation) {
        case 'bottomCenter':
            return <BottomCenterSvg {...props} />
        case 'bottomRight':
            return <BottomRightSvg {...props} />
        case 'topBalanced':
            return <TopBalancedSvg {...props} />
    }
}

const StyledWave = styled(Wave)`
  position: absolute;
  width: 100%;
  height: ${props => props.height / 2}px;
  left: 0;
  
  ${props => props.orientation.startsWith('bottom') && css`
    bottom: -1px;  // compensates for a slight spacing that remains at the bottom of the SVG
  `}
  ${props => props.orientation.startsWith('top') && css`
    top: -1px;  // compensates for a slight spacing that remains at the bottom of the SVG
  `}

  ${media.from.tablet(css`
    height: ${props => props.height}px;
  `)}
`;

const Background = styled.div`
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  
  ${props => props.mode === 'solid' && css`
    background-color: var(--color-light-gray-background);
  `}
`;

const ContentWrapper = styled.div`
  padding-top: ${props => props.paddingTop}px;
  padding-bottom: ${props => props.paddingBottom}px;
`;

const ContainerIfNeeded = ({fullWidth, children}) => fullWidth ? children : <Container>{children}</Container>;


const ChildrenWrapper = styled.div`
  ${props => props.withPadding && css`
    padding: 20px;

    ${media.from.tablet(css`
      padding: 40px;
    `)}
  `}
`;


const ContentBlock = ({fullWidth = false, mode = 'transparent',
                          wavePosition = 'outset', waveOrientation = undefined, waveHeight = 150,
                          background = undefined, children, ...props}) => {
    return (
        <StyledSection mode={mode} {...props}>
            <ContainerIfNeeded fullWidth={fullWidth}>
                <ContentWrapper paddingTop={wavePosition === 'outset' && waveOrientation?.startsWith('top') ? waveHeight : 0}
                                paddingBottom={wavePosition === 'outset' && waveOrientation?.startsWith('bottom') ? waveHeight : 0}>
                    <Background mode={mode}>{background}</Background>
                    {waveOrientation && <StyledWave height={waveHeight} orientation={waveOrientation} />}
                    <ChildrenWrapper withPadding={!fullWidth}>
                        {children}
                    </ChildrenWrapper>
                </ContentWrapper>
            </ContainerIfNeeded>
        </StyledSection>
    )
}

ContentBlock.propTypes = {
    fullWidth: PropTypes.bool,
    waveOrientation: PropTypes.oneOf(['bottomCenter', 'bottomRight', 'topBalanced']),
    waveHeight: PropTypes.number,
    wavePosition: PropTypes.oneOf(['inset', 'outset']),
    mode: PropTypes.oneOf(['solid', 'transparent']),
}

export default ContentBlock;
